import type { ActivityPort, ActivityProfileView, ShopInsights } from './ports.ts';
import type { WorkerClient } from './worker.ts';

// In-app activity, sent in batches by features/activity/tracker.ts. Only the
// Worker stores it; nothing here reads other people's activity.
export function createActivity(worker: WorkerClient): ActivityPort {
  return {
    record: async batch => { await worker.call('record_activity', batch); },
    mine: () => worker.call<ActivityProfileView>('get_my_activity'),
    setPersonalise: async on => { await worker.call('set_personalisation', { on }); },
    clear: async () => { await worker.call('clear_my_activity'); },
    shopInsights: (shopId, days) => worker.call<ShopInsights>('get_shop_insights', { shopId, days }),
  };
}
